import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import { DropBoxFileInterface } from '../../types/dropBox.type';
import BaseAdapter from './baseAdapter';
import { DropBoxFileResponse } from '../../api-models';

export default class GetDropBoxFiles extends BaseAdapter<DropBoxFileResponse[]> implements AdapterInterface {
  rawResponse: DropBoxFileResponse[];

  async adaptResponse(): Promise<DropBoxFileInterface[]> {
    await this.fetchApiResponse('/api/drop-box/files', HTTPMethod.Get);
    return this.displayResponse();
  }

  displayResponse(): DropBoxFileInterface[] {
    return this.rawResponse.map((file) => ({
      fileName: file.file_name,
      s3Key: file.s3_key,
      uploadedBy: file.uploaded_by,
      uploadedAt: file.uploaded_at,
      expiresAt: file.expires_at,
      scanStatus: file.scan_status,
      id: file.s3_key,
    }));
  }
}
